/**
 * The external dependecies
 */
import React from "react";

/**
 * The internal dependencies.
 */
import ModalFrame from "./ModalFrame";
import FormCreateCohort from "components/form/FormCreateCohort";

/**
 * @class      ModalCreateCohort (name)
 * @param      {Object} / The properties
 * @return     {JSX}
 */
const ModalCreateCohort = (props) => {
  return (
    <ModalFrame>
      <FormCreateCohort />
    </ModalFrame>
  );
};

export default ModalCreateCohort;
